export default function createSearchParams(params) {
  if (params === null || params === undefined) return ''

  return new URLSearchParams(params).toString()
}